import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CircleButton from '../components/CircleButton';
// import LanguageButton from '../components/LanguageButton';
import PortraitStage from '../components/PortraitStage';
import ScreenHeader from '../components/ScreenHeader';
import { ArrowRight, LayersIcon } from '../components/icons';
import { readContribution } from '../utils/contribution';

function PlainArrowLeft() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M19 12H5M5 12l6-6M5 12l6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ThankYouScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const fromNav = location.state;
  const entry =
    fromNav && (typeof fromNav.message === 'string' || typeof fromNav.photo === 'string')
      ? fromNav
      : readContribution();
  const photo = entry?.photo || '';
  const message = entry?.message || '';

  useEffect(() => {
    const timer = window.setTimeout(() => {
      navigate('/', { replace: true });
    }, 10000);
    return () => window.clearTimeout(timer);
  }, [navigate]);

  return (
    <PortraitStage>
      <section className="thankYou" aria-labelledby="thank-title">
        <ScreenHeader
          title="Mosida"
          subtitle="Social Collage"
          // action={<LanguageButton />}
        />

        <main className="thankYou__main">
          <LayersIcon className="thankYou__mark" />
          <h1 id="thank-title" className="thankYou__title">
            Thank you!
          </h1>
          <p className="thankYou__prompt">
            Your contribution
            <br />
            is now part of
            <br />
            the collective artwork.
          </p>

          {photo || message ? (
            <figure className={`thankYou__card${photo ? '' : ' thankYou__card--messageOnly'}`}>
              {photo ? <img src={photo} alt="" /> : null}
              {message ? <figcaption className="thankYou__message">{message}</figcaption> : null}
            </figure>
          ) : null}

          <div className="thankYou__actions">
            <button type="button" className="thankYou__another" onClick={() => navigate('/add-contribution')}>
              <PlainArrowLeft />
              Add another
            </button>
            <CircleButton
              className="circleButton--seeWall"
              label={
                <>
                  See it on
                  <br />
                  the wall
                </>
              }
              ariaLabel="See it on the wall"
              icon={<ArrowRight />}
            />
          </div>
        </main>
      </section>
    </PortraitStage>
  );
}

export default ThankYouScreen;
